import { useState } from 'react';
import { getLSItem, setLSItem } from "v4/services/localStorage.service";

export const NOTIFY_ME_STORAGE_KEY = 'notifyMe';

const STATES = {
    undefined: {
        className: 'is-undefined',
        icon: 'bell-question',
        tip: 'notify_me_undefined_tip',
    },
    enabled: {
        className: 'is-enabled',
        icon: 'bell-ringing',
        tip: 'notify_me_enabled_tip',
    },
    disabled: {
        className: 'is-disabled',
        icon: 'bell-x',
        tip: 'notify_me_disabled_tip',
    },
    blocked: {
        className: 'is-blocked',
        icon: 'bell-x',
        tip: 'notify_me_blocked_tip',
    },
}

function getInitialState() {
    if (!('Notification' in window) || Notification.permission === 'denied') return 'blocked';
    if (Notification.permission === 'default') return 'undefined';

    // permission === 'granted' : localStorage distingue enabled vs disabled
    const stored = getLSItem(NOTIFY_ME_STORAGE_KEY, 'string');
    if (stored === 'disabled') return 'disabled';
    return 'enabled';
}

function saveState(state) {
    setLSItem(NOTIFY_ME_STORAGE_KEY, state);
}

export default function useNotifyMe() {
    const [currentState, setCurrentState] = useState(getInitialState);

    const onClick = async () => {
        if (currentState === 'undefined') {
            const permission = await Notification.requestPermission();
            const next = permission === 'granted' ? 'enabled' : 'blocked';
            saveState(next);
            setCurrentState(next);
        } else if (currentState === 'enabled') {
            saveState('disabled');
            setCurrentState('disabled');
        } else if (currentState === 'disabled') {
            saveState('enabled');
            setCurrentState('enabled');
        }
        // blocked → no-op
    }

    return {
        state: STATES[currentState],
        onClick,
    }
}
